@if (params?.data) {
    <div class="d-flex flex-column py-2 px-3 h-100 overflow-hidden">
        <div
            class="text-muted text-truncate audit-diff-field"
            [title]="params.data.field"
        >
            {{ params.data.field }}
        </div>
        <div class="text-break audit-diff-value">
            {{ params.value || '-' }}
        </div>
    </div>
}
